import { IBreadcrumbStyles, IStyle, mergeStyleSets } from "@fluentui/react";
import { IDonutChartStyles, IVerticalBarChartStyles } from "@fluentui/react-charting";
import { IFilterPillStyles } from "@m365-admin/in-page-filter";
import React, { CSSProperties } from "react";

export const HEALTH_VIEW_STYLES = {
  COMMON_STYLES: {
    CLASS_NAMES: mergeStyleSets({
      customCardContainer: {
        columnGap: 10,
        display: "flex",
        margin: 0,
        flex: 1
      } as CSSProperties
    }),
    CSS_STYLES: {
      donutChart: {
        legendContainer: { width: "100%", maxWidth: 400, "& div": { marginLeft: 0 } },
        root: { marginBottom: 24, marginTop: 28 }
      } as IDonutChartStyles,
      verticalBarChart: {
        legendContainer: { width: "100%", maxWidth: 400, "& div": { marginLeft: 0 } },
        root: { marginBottom: 24, marginTop: 28, height: 250 },
        opacityChangeOnHover: undefined,
        barLabel: undefined
      } as IVerticalBarChartStyles
    },
    COUNT_ANNOTATION: mergeStyleSets({
      cardContent: {
        paddingLeft: "12px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start"
      } as CSSProperties,
      overviewContainer: { paddingTop: "5px", paddingBottom: "5px" } as CSSProperties,
      mainContainerStyle: {
        display: "contents",
        width: "100%"
      } as CSSProperties,
      metricsContainer: { display: "flex", flexDirection: "column", flexWrap: "nowrap", width: "100%", maxWidth: "100%", rowGap: "10px" } as CSSProperties
    })
  },
  OVERVIEW_SECTION: {
    cardContent: { padding: 0, paddingLeft: 12 } as React.CSSProperties,
    cardRoot: { maxWidth: "" } as IStyle,
    tabsCardRoot: { maxWidth: "", padding: 10, boxShadow: "var(--customShimmerShadow4)" } as IStyle,
    overviewContainer: { paddingTop: 18, paddingBottom: 18 } as React.CSSProperties,
    selectedMetricCard: { backgroundColor: "lightcyan" } as IStyle,
    shimmerStyles: {
      root: {
        gap: 13,
        height: 61,
        margin: 0,
        paddingLeft: 12,
        paddingRight: 12
      },
      articleContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        padding: 0
      },
      lineContainer: {
        backgroundColor: "inherit !important",
        margin: "0 !important"
      }
    },
    NoDataStyles: {
      display: "flex",
      alignItems: "center",
      height: 70,
      justifyContent: "center"
    } as React.CSSProperties
  },
  HEALTH_PAGE: {
    CLASS_NAMES: mergeStyleSets({
      healthPageContainer: {
        margin: 12,
        backgroundColor: "#fff"
      }
    }),
    CSS_STYLES: {
      HealthViewCustomBreadcrumb: {
        root: {
          fontSize: 14,
          margin: 0,
          paddingLeft: 8,
          width: 500,
          "--itemLink-color": "rgb(0, 120, 212)"
        },
        item: {
          fontSize: "inherit"
        },
        itemLink: {
          fontSize: "inherit",
          color: "var(--itemLink-color)",
          ":hover": {
            background: "none",
            textDecoration: "underline",
            color: "var(--itemLink-color)"
          }
        }
      } as Partial<IBreadcrumbStyles>
    }
  },
  HEALTH_VIEW_FILTER_PILL: {
    STYLES: {
      root: {
        margin: "4px",
        flex: "0 1 auto",
        minWidth: 0
      },
      subComponentStyles: {
        contextualMenu: {
          container: { height: "auto", transition: "min-width 1s ease-in-out" },
          list: { maxHeight: "calc(80vh / 2)", overflow: "auto", "& .ms-ContextualMenu-link": { height: "auto" } }
        },
        callout: { calloutMain: {} }
      }
    } as Partial<IFilterPillStyles>
  }
};
